module.exports = __webpack_public_path__ + "static/img/CLJG.f54ffa0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/CLJG.png
// module id = DoY/
// module chunks = 2